<template>
  <div>
    <div class="h-full w-full flex flex-col mt-0 md:mt-16">
      <div class="h-full w-full px-4 flex flex-col items-center md:items-start">
        <div class="flex flex-col justify-center wd-340 xs:wd-380 md:wd-auto">
          <h1 class="font-light text-slategrey text-lg xs:text-xl lg:text-2xl text-center md:text-left">We’re always on the lookout for exceptional talent.</h1>
          <h1 class="font-light text-slategrey text-lg xs:text-xl lg:text-2xl text-center md:text-left mt-8">If that’s you and you’re passionate about the intersection between technology and equitable access to mental healthare, email us your resume at <a class="text-rspurple" href="mailto:hr@yourdailyreset.com">hr@yourdailyreset.com.</a></h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "",
    components: {},
    props: {
    },
    created() {
    },
    computed: {
    },
    data() {
        return {};
    },
}
</script>

<style lang="scss" scoped>
@responsive {
  .wd-340 {
      width: 340px;
      max-width: 100%;
  }
  .wd-380 {
      width: 380px;
  }
  .wd-auto {
      width: auto;
  }
}
</style>
